export default {
  refundRecord_00001: "Registro de reembolso",
  refundRecord_00002: "Fecha de reembolso",
  refundRecord_00003: "Monto del reembolso ({0})",
  }